<template>
  <div v-if="(hideIfOnePage && totalPages > 1) || (!hideIfOnePage)" class="pagination-wrapper flex align-items-center justify-center">
    <WhiteButton :is-disabled="!canPaginatePrev" @click="paginate('prev')" class="pagination-nav pagination-nav-prev">
      <ThinArrowIcon direction="left" />
    </WhiteButton>

    <template v-if="totalPages <= 7">
      <WhiteButton
        v-for="page in totalPages"
        :key="page"
        :class="{ 'pagination-active': page === currentPage }"
        @click="goToPage(page)"
        class="pagination-number"
      >
        {{ page }}
      </WhiteButton>
    </template>
    <template v-else>
      <WhiteButton
        :class="{ 'pagination-active': 1 === currentPage }"
        @click="goToPage(1)"
        class="pagination-number"
      >
        1
      </WhiteButton>

      <WhiteButton
        :class="{ 'pagination-active': 2 === currentPage }"
        @click="goToPage(2)"
        class="pagination-number"
        v-if="currentPage <= 4"
      >
        2
      </WhiteButton>

      <WhiteButton
        :class="{ 'pagination-active': 3 === currentPage }"
        @click="goToPage(3)"
        class="pagination-number"
        v-if="currentPage <= 4"
      >
        3
      </WhiteButton>

      <span v-if="currentPage > 4" class="pagination-dots">...</span>

      <template v-if="currentPage > 4 && currentPage < totalPages - 3">
        <WhiteButton
          @click="goToPage(currentPage - 1)"
          class="pagination-number"
        >
          {{ currentPage - 1 }}
        </WhiteButton>

        <WhiteButton
          class="pagination-number pagination-active"
        >
          {{ currentPage }}
        </WhiteButton>

        <WhiteButton
          @click="goToPage(currentPage + 1)"
          class="pagination-number"
        >
          {{ currentPage + 1 }}
        </WhiteButton>
      </template>

      <span v-if="currentPage < totalPages - 3" class="pagination-dots">...</span>

      <WhiteButton
        :class="{ 'pagination-active': (totalPages - 2) === currentPage }"
        @click="goToPage(totalPages - 2)"
        class="pagination-number"
        v-if="currentPage >= totalPages - 3"
      >
        {{ totalPages - 2 }}
      </WhiteButton>

      <WhiteButton
        :class="{ 'pagination-active': (totalPages - 1) === currentPage }"
        @click="goToPage(totalPages - 1)"
        class="pagination-number"
        v-if="currentPage >= totalPages - 3"
      >
        {{ totalPages - 1 }}
      </WhiteButton>

      <WhiteButton
        :class="{ 'pagination-active': totalPages === currentPage }"
        @click="goToPage(totalPages)"
        class="pagination-number"
      >
        {{ totalPages }}
      </WhiteButton>
    </template>

    <WhiteButton :is-disabled="!canPaginateNext" @click="paginate('next')" class="pagination-nav pagination-nav-next">
      <ThinArrowIcon direction="right" />
    </WhiteButton>
  </div>
</template>

<script>
import { paginator } from '../lib';
import { WhiteButton } from '@/shared/ui/form';
import { ThinArrowIcon } from '@/shared/ui/icons';

export default {
  props: {
    hideIfOnePage: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ paginator ],
  components: { WhiteButton, ThinArrowIcon },
  methods: {
    goToPage(page) {
      if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
        this.$emit('page-changed', page);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  margin: 12px 24px;
  gap: 4px;
}

.pagination-nav {
  min-width: 32px;
  height: 36px;
  background-color: #ffffff;
  border: 1px solid #D5D7DA;
  padding: 8px 12px;
  box-shadow: 0px 1px 2px 0px #0A0D120D;

  &-prev {
    margin-right: 45px;

    @media (max-width: 500px) {
      margin-right: 5px;
    }
  }

  &-next {
    margin-left: 45px;

    @media (max-width: 500px) {
      margin-left: 5px;
    }
  }
}

.pagination-number {
  height: 40px;
  min-width: 32px;
  background-color: transparent;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #252B37;
}

.pagination-active {
  background-color: #FAFAFA !important;
}

.pagination-dots {
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 14px;
  font-weight: 500;
  color: #252B37;
}
</style>
